import {useLMapStateHook} from '@/assets/leaflet/assets/hooks/LMapStateHook';

import {generateUUIDv4} from '@/assets/core/assets/helpers/generate';

const target = generateUUIDv4();

export const atlasMapState = useLMapStateHook(target);
